import { TYPES } from "../consts";
const resolveColor = () => ({
  theme,
  selected,
  type
}) => {
  if (selected) return theme.orbit.paletteWhite;
  return type === TYPES.NEUTRAL ? theme.orbit.paletteInkDark : theme.orbit.paletteBlueDarker;
};
export default resolveColor;